import KaistoreHawkHelper from 'kaistore-hawk-helper/lib';

/*
 * ?cu=40440-2AAQUS0
 *  &imei=123123123123123
 *  &simMCC=null&simMNC=null&currentMCC=null&currentMNC=null
 *
 */
class KaiStoreCategoriesHelper {
  constructor() {
    this.apiName = 'categories';
  }

  init({
    deviceInfo,
    imei,
    commsInfo,
    serverTimeOffset,
    useCustomConnectionType = false
  }) {
    this.deviceInfo = deviceInfo;
    this.imei = imei;
    this.commsInfo = commsInfo;
    this.serverTimeOffset = serverTimeOffset;
    this.useCustomConnectionType = useCustomConnectionType;
  }

  _getDeviceInfo(InfoList) {
    return InfoList.map(key => {
      const deviceInfo = this.deviceInfo.get(key);

      if (!this.deviceInfo.has(key)) {
        console.error(
          `ArgumentError: Expected deviceInfo Map to have keys [${key}]`
        );
      }

      return deviceInfo;
    });
  }

  getCategories() {
    const [cu, defaultServiceId] = this._getDeviceInfo([
      'deviceinfo.cu',
      'ril.data.defaultServiceId'
    ]);
    const params = Object.assign(
      {},
      {
        cu,
        defaultServiceId,
        imei: this.imei
      },
      this.commsInfo
    );

    return new Promise((resolve, reject) => {
      let requester = KaistoreHawkHelper.getRequester({
        serverTimeOffset: this.serverTimeOffset,
        deviceInfos: this.deviceInfo,
        useCustomConnectionType: this.useCustomConnectionType
      });

      requester
        .send({
          url: KaistoreHawkHelper.generateURL({
            apiName: this.apiName,
            params,
            deviceInfos: this.deviceInfo
          }),
          method: 'GET'
        })
        .then(
          response => {
            resolve(JSON.parse(response));
          },
          error => {
            console.error('categories:' + error.statusText);
            // pass empty array.
            resolve([]);
          }
        );
    });
  }
}

export default KaiStoreCategoriesHelper = new KaiStoreCategoriesHelper();



/** WEBPACK FOOTER **
 ** ./~/kaistore-categories-helper/lib/index.js
 **/